import { createSlice } from '@reduxjs/toolkit';
import { BoundingBox } from '@planitgeo/treeplotter-domain/lib/infrastructure/geo/geo.interface';

export interface OrganizationEntity {
  id: string;
  name: string;
  tenantId?: string;
  tp2OrganizationId?: number | null;
  center?: {
    lat: number;
    lng: number;
  };
  boundingBox?: BoundingBox;
}

export type PrefetchingStatus = 'loading' | 'completed' | 'error' | null;

type IOrganizationState = {
  currentOrganization: OrganizationEntity | null;
  prefetchingStatus: PrefetchingStatus;
  useMapOrganizationBoundingBox: boolean;
};

const initialState: IOrganizationState = {
  currentOrganization: null,
  prefetchingStatus: null,
  useMapOrganizationBoundingBox: true,
};

const slice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    saveCurrent(state: IOrganizationState, action: { payload: OrganizationEntity }) {
      return {
        ...state,
        currentOrganization: action.payload,
        useMapOrganizationBoundingBox: true,
      };
    },
    clearCurrent(state: IOrganizationState) {
      return {
        ...state,
        currentOrganization: null,
        useMapOrganizationBoundingBox: true,
      };
    },
    setPrefetchingStatus(state: IOrganizationState, action: { payload: PrefetchingStatus }) {
      return {
        ...state,
        prefetchingStatus: action.payload,
      };
    },
    setUseMapOrganizationBoundingBox(state: IOrganizationState, action: { payload: boolean }) {
      return {
        ...state,
        useMapOrganizationBoundingBox: action.payload,
      };
    },
  },
});

const { reducer } = slice;
const { saveCurrent, clearCurrent, setPrefetchingStatus, setUseMapOrganizationBoundingBox } =
  slice.actions;

if (!reducer) {
  throw new Error('No reducer found for organizations');
}

// eslint-disable-next-line import/no-unused-modules
export {
  reducer,
  slice,
  saveCurrent,
  clearCurrent,
  setPrefetchingStatus,
  setUseMapOrganizationBoundingBox,
};
